export const FETCH_ADSENSE_TRANSACTIONS = 'EARNINGS/FETCH_ADSENSE_TRANSACTIONS';
export const FETCH_ADSENSE_TRANSACTIONS_ERROR = 'EARNINGS/FETCH_ADSENSE_TRANSACTIONS_ERROR';
export const CLEAR_ADSENSE_TRANSACTIONS = 'EARNINGS/CLEAR_ADSENSE_TRANSACTIONS';
